import {Textarea} from 'platform/components';

import {KeyboardEventHandler, useRef} from 'react';

import {RequiredTestIdProps, suffixTestId, useOnMount} from 'shared/web';

const PROMPT_MIN_ROWS = 1;
const PROMPT_MAX_ROWS = 4;

interface AiComposerPromptInputProps extends RequiredTestIdProps {
  label: string;
  placeholder: string;
  value: string;
  isDisabled: boolean;
  isAutoFocused?: boolean;
  onChange: (value: string | null) => void;
  onSubmit: () => void;
}

export function AiComposerPromptInput(props: AiComposerPromptInputProps) {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useOnMount(() => {
    if (props.isAutoFocused !== false) {
      inputRef.current?.focus();
    }
  });

  const handleKeyDown: KeyboardEventHandler<HTMLTextAreaElement> = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      props.onSubmit();
    }
  };

  return (
    <Textarea
      ref={inputRef}
      aria-label={props.label}
      placeholder={props.placeholder}
      value={props.value}
      minRows={PROMPT_MIN_ROWS}
      maxRows={PROMPT_MAX_ROWS}
      isScrollable
      isBorderless
      isDisabled={props.isDisabled}
      onChange={props.onChange}
      onKeyDown={handleKeyDown}
      data-testid={suffixTestId('prompt', props)}
    />
  );
}
